import React from 'react';

function Config({ params }) {
    return (
        <div style={{
            backgroundColor: '#18181b',
            color: 'white',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px',
            fontFamily: 'Arial, sans-serif'
        }}>
            <p
                style={{
                    textAlign: 'center',
                    maxWidth: '600px',
                    lineHeight: '1.6',
                    fontSize: '16px'
                }}
            >
                To get access to the extension or for any feedback/bug reports, join our Discord and contact me:
                {' '}
                <a
                    href="https://discord.gg/PhBnBJ9pjd"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#5865F2', fontWeight: 'bold', textDecoration: 'none' }}
                >
                    discord.gg/PhBnBJ9pjd
                </a>
            </p>
        </div>
    );
}

export default Config;